import React, {Fragment, useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {useLocation} from "react-router-dom";
import {Card, CardBody, CardHeader, Col, Modal, Row} from "reactstrap";
import {CustomHeader, RequiredItemsBadge} from "@pages/new-design-components/custom-components";
import {ClipLoader} from "react-spinners";
import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {
  DELETE_NOTE_REQUEST,
  GET_COMMUNICATION_LOGS_REQUEST,
  GET_CUSTOMER_DEBT_REQUEST,
  GET_CUSTOMER_REQUEST,
  GET_SYSTEM_NOTES_REQUEST,
  SEND_SMS_REQUEST,
  SEND_SYSTEM_NOTE_REQUEST,
  UPDATE_CUSTOMER_DEBT_REQUEST
} from "@redux/Customer/actions";
import usePrevious from "@hooks/useprevious";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import {calculateSum} from "@constants/index";
import DebtListComponent from "@pages/components/DebtManagement/CustomerOverview/DebtListComponent";
import CreateEditDebtModal from "@pages/components/DebtManagement/CustomerOverview/CreateEditDebtModal";
import CreateEditPaymentModal from "@pages/components/DebtManagement/CustomerOverview/CreateEditPaymentModal";
import CommunicationsLog from "@pages/components/DebtManagement/CustomerOverview/CommunicationsLog";
import {GET_SYSTEM_TEMPLATES_REQUEST} from "@redux/Email/actions";
import axios from "axios";
import CustomDropdownComponent from "@pages/components/JobDetailsComponents/CustomInspectionDropDown";
import notify from "@utils/notify";
import {GET_SHORTCODES_BY_TYPES_REQUEST} from "@redux/Email/actions";
import CustomerOverviewInfo from "@pages/components/DebtManagement/CustomerOverview/CustomerOverviewInfo";
import InputCustom from "@pages/components/InputCustom";
import DebtRecovery from "@pages/components/DebtManagement/CustomerOverview/DebtRecovery";
import NotesComponent from "@pages/components/DebtManagement/CustomerOverview/NotesComponent.tsx";

export default function CustomerOverview() {
  const location = useLocation()

  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);

  const customerId = queryParams.get('customer_id');
  const [loading,setLoading] = useState(true);
  const [customerData,setCustomerData] = useState({});
  const [xeroCustomerData,setXeroCustomerData] = useState({});

  const [error,setError] = useState({
    message: {
      show: false,
      message: ''
    }
  });
  const [infoDebts, setInfoDebts] = useState([]);

  const [activeTab, setActiveTab] = useState('notes');

  const {systemTemplates} = useSelector(
      (state) => state.emailTemplateState,
      shallowEqual
  );
  const { getCustomerSuccess,
          getCustomerError,
          customer,
          getSystemNotesError,
          getSystemNotesSuccess,
          customerDebts,
          getCustomerDebtError,
          getCustomerDebtSuccess,
  } = useSelector((state) => state.customer, shallowEqual);

  const profileData = useSelector((state) => state.getState).profileData;

  const getCustomerSuccessPrev = usePrevious(getCustomerSuccess);
  const getCustomerErrorPrev = usePrevious(getCustomerError);


  const getSystemNotesSuccessPrev = usePrevious(getSystemNotesSuccess);
  const getSystemNotesErrorPrev = usePrevious(getSystemNotesError);

  const getCustomerDebtSuccessPrev = usePrevious(getCustomerDebtSuccess);
  const getCustomerDebtErrorPrev = usePrevious(getCustomerDebtError);

  const tabs = [
    {
      key: 'notes',
      label: 'Notes',
    },
    {
      key: 'invoices',
      label: 'Invoices',
    },
    {
      key: 'debt_list',
      label: 'Debt Recovery',
    },
    {
      key: 'communication_log',
      label: 'Communication Log',
    },
  ]

  const noteTabs = [
    {
      key: 'all',
      label: 'All',
    },
    {
      key: 'Customer',
      label: 'Customer',
    },
    {
      key: 'Payment',
      label: 'Payment',
    },
    {
      key: 'Deal',
      label: 'Deal',
    },
    {
      key: 'DebtRecovery',
      label: 'Debt Recovery',
    },
    {
      key: 'Logistics',
      label: 'Logistics',
    },

  ]

  useEffect(()=>{
    if (getCustomerSuccess && getCustomerSuccessPrev === false) {
      setCustomerData(customer)
      fetchDebts({order_by: 'due_date',order: 'desc'})
      }
  },[getCustomerSuccess,getCustomerSuccessPrev])

  useEffect(()=>{
    if (getSystemNotesSuccess && getSystemNotesSuccessPrev === false) {
      setLoading(false)
    }
  },[getSystemNotesSuccess,getSystemNotesSuccessPrev,loading])

  useEffect(()=>{
    if (getCustomerDebtSuccess && getCustomerDebtSuccessPrev === false) {
      const tDebts = customerDebts.customer_debt;
      const editedDebts = returnDebts(tDebts)
      if (loading) {
        dispatch({
          type: GET_SYSTEM_NOTES_REQUEST,
          payload:{id: customer.id, type: 'debt'}
        });
        setInfoDebts([...editedDebts])
        setXeroCustomerData(customerDebts.xeroCustomer[0])
      }

    }
  },[getCustomerDebtSuccessPrev,getCustomerDebtSuccess,loading])

  const returnDebts = (invoicesList) => {
    return  invoicesList.filter(debt=> {
      return  new Date(debt.due_date) < new Date();
    })
  }

  useEffect(()=>{
    if (getCustomerDebtError && getCustomerDebtErrorPrev === false) {
       setLoading(false)
    }
  },[getCustomerDebtError,getCustomerDebtErrorPrev])

  useEffect(()=>{
    if (getSystemNotesError && getSystemNotesErrorPrev === false) {
      setLoading(false)
      notify.warning('Something went wrong please try again later!');
    }
  },[getSystemNotesError,getSystemNotesErrorPrev])

  useEffect(()=>{
    if (getCustomerError && getCustomerErrorPrev === false) {
       setLoading(false)
      notify.warning('Something went wrong please try again later!');
    }
  },[getCustomerError,getCustomerErrorPrev])

  useEffect(()=>{
    if (customerId) {
      dispatch({
        type: GET_CUSTOMER_REQUEST,
        payload: { id: customerId }
      });
      dispatch({
        type: GET_SYSTEM_TEMPLATES_REQUEST,
      });
      dispatch({
        type: GET_SHORTCODES_BY_TYPES_REQUEST,
      });
    }
  },[customerId])

  const fetchDebts = (tempFilter = {}) => {
    dispatch({
      type: GET_CUSTOMER_DEBT_REQUEST,
      payload: { id: customer.id, filter: tempFilter }
    });
  }
   const customerInfo = useMemo(()=> {
     return  <CustomerOverviewInfo
         debts={infoDebts}
         updateXeroCustomerData={(data)=>{
           setXeroCustomerData(data)
         }}
         customerData={customerData}
         xeroCustomerData={xeroCustomerData}
     />
   },[infoDebts,setXeroCustomerData,customerData,xeroCustomerData])

  const filterTemplatesByDeals = useMemo(() => {
    if (!systemTemplates) return [];

    const hasNoDeals = !customer?.deals || customer.deals.length === 0;

    if (hasNoDeals) {
      return systemTemplates.map(template => {
        const shouldDisable =
            template.message.includes('{{deal.') ||
            template.message.includes('{{dealer.') ||
            template.message.includes('{{vehicle.');

        return shouldDisable
            ? { ...template, disabled: true }
            : template;
      });
    }

    return systemTemplates;
  }, [systemTemplates, customer]);

  const updateCustomerNote = (value) => {
    axios({
      method: 'POST',
      url: `/debt-customer/${customerData.id}`,
      data:  {note: value},
    }).then(() => {
          notify.success('Customer successfully updated');
      }).catch(()=>{
        notify.warning('Error updating customer');
    });
  }
  const updateDebt = (data) => {
    axios({
      method: 'POST',
      url: `/debt-recovery/${data.id}`,
      data:  data,
    }).then(() => {
      notify.success('Debt successfully updated');
    }).catch(()=>{
      notify.warning('Error updating debt');
    });
  }
  return (
      loading ? <LoaderContainer>
            <ClipLoader
                css={override}
                size={40}
                color={`#7B61E4`}
                loading={loading}
            />
          </LoaderContainer>
          :
          <div className={'container-fluid debt-background pt-3'}>
               <Row>
                 {customerInfo}
                 <Col lg={9}>
                   {

                     <div className={'d-flex g-10 mb-3 flex-wrap'}>
                       {
                         tabs.map((tab,index) => {
                           return (
                               <Fragment key={'idx_'+index}>
                                 <RequiredItemsBadge type={tab.key} onClick={()=> {
                                   setActiveTab(tab.key);
                                 }
                                 } active={activeTab === tab.key}>
                                   {tab.label}
                                 </RequiredItemsBadge>
                               </Fragment>
                           )
                         })
                       }
                       <Col lg={12}>
                         {activeTab === 'notes' ?
                             <NotesComponent
                                 noteAboutCustomer={true}
                                 updateCustomer={updateCustomerNote}
                                 initialValue={xeroCustomerData?.note}
                                 profileDataId={profileData.id}
                                 customerId={customerData.id}
                                 error={error}
                                 setError={setError}
                                 noteTabs={noteTabs}
                             />
                             :  activeTab === 'invoices' ?
                                 <DebtListComponent
                                   activeTab={activeTab}
                                   customerId={customerData.id}
                                  />
                                 : activeTab === 'debt_list' ?
                                     <DebtRecovery initialData={xeroCustomerData.debt_recovery?.at(-1)}
                                                   disabled={xeroCustomerData?.customer_status !== 'sent_to_debt_recovery'}
                                                   updateDebt={updateDebt}/> :
                                 activeTab === 'communication_log' ?
                                     <CommunicationsLog
                                         profileDataId={profileData.id}
                                         customer={{
                                           mobile_number: customerData?.mobile_number,
                                           deals: customer?.deals,
                                           full_name: customerData.full_name,
                                           email: customerData.email,
                                           id: customerData.id
                                         }}
                                         systemTemplates={filterTemplatesByDeals}
                                     /> : <></>
                         }
                       </Col>
                     </div>
                   }
                 </Col>
               </Row>
          </div>

  )
}